import React, { createContext, useState } from "react";
export const SidebarContext = createContext(void 0);
export const SidebarProvider = ({ children }) => {
  const [sidebar, setSidebar] = useState(null);
  const clearSidebar = () => {
    setSidebar(null);
  };
  return /* @__PURE__ */ React.createElement(SidebarContext.Provider, { value: { sidebar, clearSidebar, setSidebar } }, children);
};
